import React, { useEffect, useRef } from "react";
import CustomExamWrapperView from "./customExamWrapperView";
import { MathJaxContext } from "better-react-mathjax";
import mathJaxConfig from "./mathJaxConfig";
import Loading from "./loading";

const CustomExamViewGradedWrapper = ({ scrollAmount, updateScrollAmount, status, endedExam, error, testsConfigDict, requestLifeCycleTwo, pdfUrls, isDarkTheme, updateIsDarkTheme, contents, gradedQuestions, requestLifeCycle }) => {
    const ref = useRef(null);

    useEffect(() => {
        if (ref.current) {            
            ref.current.scrollTo({ top: scrollAmount, behavior: "instant" });
        }

    }, [])

    return (
        <>
            {

                requestLifeCycle

                ?

                <div className="loading-zip-container">
                    <Loading />
                </div>

                :

                <>
                    <div ref={ref} className="custom-programming-exam-wrapper" style={{ position: "relative" }} onScroll={(e) => {
                        updateScrollAmount(e.target.scrollTop);                            
                    }}>
                        <MathJaxContext config={mathJaxConfig}>
                            <CustomExamWrapperView status={status} endedExam={endedExam} error={error} testsConfigDict={testsConfigDict} requestLifeCycleTwo={requestLifeCycleTwo} pdfUrls={pdfUrls} isDarkTheme={isDarkTheme} updateIsDarkTheme={updateIsDarkTheme} useSyntaxHighlighting={true} contents={contents} questions={gradedQuestions} grading={true}/>
                        </MathJaxContext>
                    </div>
                </>

            }
        </>
    );
}

export default CustomExamViewGradedWrapper;